import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import colors from "@constants/color";
import getWalletIcon from "./WalletIcon";
import AmountTag from "./AmountTag";
import { WalletTxnType } from "../utils";

type TransactionHeaderProps = {
  summary: {
    value_txt: string;
    title: string;
    key: string;
    summary_amount_status: any;
    delivered_customers: any;
  };
};

const TransactionHeaderCard: React.FC<TransactionHeaderProps> = ({
  summary,
}) => {
  return (
    <>
      <View style={styles.headerContainer}>
        {getWalletIcon(summary?.key)}
        <View style={{ marginLeft: 12, flex: 1 }}>
          <View style={styles.headerTextContainer}>
            <Text style={styles.headerAmount}>{summary?.value_txt}</Text>
            <Text
              variant="body_text_3"
              style={styles.headerLabel}
              numberOfLines={2}
            >
              {summary?.title}
            </Text>
          </View>
        </View>
      </View>
      {summary?.key == WalletTxnType.DELIVERY_FEE && (
        <AmountTag
          processing={summary?.summary_amount_status?.processing}
          processed={summary?.summary_amount_status?.processed}
          deliveredCustomer={summary?.delivered_customers}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 14,
    backgroundColor: colors.white,
    borderRadius: 8,
    elevation: 1,
    marginHorizontal: 16,
    paddingHorizontal: 16,
  },
  headerTextContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerAmount: {
    fontSize: 30,
    fontWeight: "bold",
    color: colors.mediumBlack,
    lineHeight: 40,
  },
  headerLabel: {
    color: colors.black06,
    marginLeft: 12,
    flex: 1,
  },
  withdrawText: {
    color: colors.darkGrey,
    marginRight: 4,
  },
  chevronIcon: {
    height: 12,
    width: 12,
  },
});

export default TransactionHeaderCard;
